'use strict'

const React = require( 'react' )
const classNames = require( 'classnames' )
const LocationDropDown = require( './location-dropdown.jsx' )
const TerminalSelect = require( './terminal-dropdown.jsx' )
const TimeSelect = require( './times-dropdown.jsx' )
const TimeSelectFlight = require( './times-dropdown-flight.jsx' )
const FlightInput = require('../flight-lookup/flight-input.jsx')
const SearchButton = require( './searchButton.jsx' )
const EngineHelper = require( './engineHelper.js' )
const DateHelper = require( '../../../../../_plugins/lib/dateHelper.js' )
const Helpers = require( '../../../../../_plugins/lib/helpers.js' );
const propTypes = require('prop-types');
const HiddenInputs = require( './hiddenInputs.jsx' )
const { string, object, bool } = propTypes
const createReactClass = require('create-react-class');

const ParkingEngine = createReactClass({
  mixins: [EngineHelper, Helpers],

  propTypes: {
    Location: string,
    domainSettings: object,
    formSettings: object,
    ArrivalDate: propTypes.instanceOf(Date),
    DepartDate: propTypes.instanceOf(Date),
    engineSearchField: string,
    hiddenLocation: string,
    agentData: object,
    agentSettings: object,
    selected: string,
    locations: object,
    pageData: object,
    showFlight: bool,
    terminalLink: bool,
    showFlightDropdown: bool
  },

  getInitialState() {
    const { hiddenLocation, Location, locations: { terminals }, formSettings, terminalLink, showTerminalsField } = this.props
    return {
      hiddenInputs: {},
      terminalLocation: hiddenLocation || Location || formSettings.defaultParkingLocation,
      showTerminalDropdown: (showTerminalsField && terminals && !terminalLink),
      showFlightModal: false,
      flightTime: this.engineCookies('flightTime') || this.adjustFlightDefaultTime(formSettings.defaultArrivalTime),
      ArrivalTime: this.engineCookies('ArrivalTime') || formSettings.defaultArrivalTime,
      DepartTime: this.engineCookies('DepartTime') || formSettings.defaultDepartTime,
      ArrivalDate: this.props.ArrivalDate,
      DepartDate: this.props.DepartDate,
      terminal: this.engineCookies('terminal') || '',
      savedFlight: this.engineCookies('FlightNumber') || ''
    }
  },

  getDefaultProps() {
    return {
      hiddenLocation: '',
      engineSearchField: '',
      ArrivalDate: DateHelper.alterDateByNumberOfDays( new Date( ), 1 ),
      DepartDate: DateHelper.alterDateByNumberOfDays( new Date( ), 8 ),
      selected: 'cp',
      showFlight: true,
      terminalLink: false,
      showFlightDropdown: false
    }
  },

  componentDidMount() {
    window.addEventListener('storageUpdate', this.setStateFromLocalStorage)
    this.getHiddenInputs( )
    this.setStateFromLocalStorage()
  },

  componentWillUnmount () {
    window.removeEventListener('storageUpdate', this.setStateFromLocalStorage)
  },

  /* ---------------------------- Date manipulation ---------------------------- */

  /**
  * Take a string of a date and return an object from it with information about the date
  * @param {string} dateString - A string with the format: dd/mm/yy
  * @return {object} - An object with the keys: day, month and year
  */
  getDateInfo (dateString) {
    const segmentedDate = dateString.split('/')
    const century = new Date().getFullYear().toString().slice(0, 2)
    const correctMonth = parseInt(segmentedDate[1]) - 1
    return {
      day: segmentedDate[0],
      month: correctMonth,
      year: `${century}${segmentedDate[2]}`
    }
  },

  parseDate (dateObj) {
    return Date.parse(dateObj)
  },

  /* ---------------------------- Set state from local storage ---------------------------- */

  /**
  * Returns the contents of the 'desktopEngineCPSSG' key in localStorage or undefined if it doesn't exist
  * @return {object} - The contents of 'desktopEngineCPSSG' in window.localStorage
  * @return {undefined} - When the 'desktopEngineCPSSG' key does not exist
  */
  getLocalStoreIfExists () {
    if (!window.localStorage['desktopEngineCPSSG']) return
    return JSON.parse(window.localStorage['desktopEngineCPSSG'])
  },

  /**
  * Set the state of a date in the react component from localStorage
  * @param {string} dateType - The key to the value you are trying to access in localStorage, eg: 'ArrivalDate'
  */
  setDateFromLocalStorageInfo (dateType) {
    const localStore = this.getLocalStoreIfExists()
    if (!localStore) return
    const dateInfo = localStore[dateType] ? this.getDateInfo( localStore[dateType] ) : null
    if (!dateInfo) return
    const dateObject = new Date(dateInfo.year, dateInfo.month, dateInfo.day)
    this.setState({ [dateType]: dateObject })
  },

  /**
  * Set the state of a time in the react component from localStorage
  * @param {string} timeType - The key to the value you are trying to access in localStorage, eg: 'ArrivalTime'
  */
  setTimeFromLocalStorageInfo (timeType) {
    const localStore = this.getLocalStoreIfExists()
    if (!localStore) return
    const time = localStore[timeType] ? localStore[timeType] : null
    if (time) this.saveTime(timeType, time)
  },

  /**
  * When the localStorage updates, use it to update the component state
  */
  setStateFromLocalStorage () {
    this.setDateFromLocalStorageInfo('ArrivalDate')
    this.setDateFromLocalStorageInfo('DepartDate')
    this.setTimeFromLocalStorageInfo('ArrivalTime')
    this.setTimeFromLocalStorageInfo('DepartTime')
  },

  /* ---------------------------- Set state from local storage end ---------------------------- */

  /**
  * Get the name of the page the user is currently on
  * @returns {string} - The name of the page with the .html extension, if on the home page returns an empty string.
  */
  getFullPageName () {
    const { pageData: { pageName } } = this.props
    return pageName !== 'index' ? `${pageName}.html` : ''
  },

  locationSelected( terminalLocation ) {
    this.setState({ terminalLocation })
  },

  showTerminals( ) {
    const { locations } = this.props
    const { terminalLocation } = this.state
    return locations.terminals && locations.terminals[terminalLocation]
  },

  showTerminalField (e) {
    if (e) e.preventDefault()
    this.setState({ showTerminalDropdown: true })
    return false
  },

  terminalsDropdown (className) {
    const { pageData: { pageName }, locations } = this.props
    const pagesName = this.getFullPageName()
    const { terminalLocation } = this.state
    return (
      <li className={className||''}>
        <label>Terminal</label>
        <TerminalSelect name="terminal" pagesName={ pagesName } locations={ locations } location={ terminalLocation } />
      </li>
    )
  },

  changedFlight (flight) {
    if (!flight) return
    const { terminal } = this.state
    if (flight.departure.terminal === terminal) return
    this.terminalSelect('terminal', flight.departure.terminal)
    this.showTerminalField()
  },

  terminalSelect (name, value) {
    if (value === 'Show all') value = ''
    this.engineCookies(name, value)
    this.setState({ terminal: value })
  },

  saveFlightTime (time) {
    const wrongTimeFormat = time.slice(-2) !== '00'
    const newFormat = (Number(time.slice(0, 2)) + 1) + '00'
    const validTimeFormatted = wrongTimeFormat ? newFormat : time
    this.saveTime('flightTime', this.adjustFlightDefaultTime(validTimeFormatted))
  },

  focusFlightSearch () {
    const flightSearchDOM = ReactDOM.findDOMNode(this).querySelector('#flightSearch input')
    if (!flightSearchDOM) return
    else flightSearchDOM.focus()
  },

  saveTime (timeType, value) {
    const { showFlightDropdown } = this.props
    const { terminal } = this.state
    this.engineCookies(timeType, value)
    this.setState({ [timeType]: value })
    if (timeType === 'ArrivalTime' && showFlightDropdown) this.saveFlightTime(value)
    if (timeType === 'ArrivalTime' && terminal) this.focusFlightSearch()
  },

  adjustFlightDefaultTime (value) {
    let newDate = Number(value) + 200
    if (newDate > 2359) newDate -= 2400
    if (!newDate) return '0000'
    return DateHelper.pad(newDate, 4)
  },

  /**
  * If the flight is earlier than arrival at the airport, assume the flight is the next day and increment the date by one.
  * @returns {Date} - The date of the flight
  */
  ensureFlightIsLaterThanArrival () {
    const { flightTime, ArrivalTime, ArrivalDate } = this.state
    if (Number(flightTime) < Number(ArrivalTime)) {
      const newFlightDate = DateHelper.alterDateByNumberOfDays(new Date(ArrivalDate), 1)
      return newFlightDate
    }
    return ArrivalDate
  },

  render() {
    const {
      Location,
      pageData: { pageName },
      domainSettings,
      engineSearchField,
      hiddenLocation,
      agentData,
      selected,
      formSettings,
      locations,
      showFlight,
      terminalLink,
      showFlightDropdown
    } = this.props
    const pagesName = this.getFullPageName()
    const {
      ArrivalDate,
      DepartDate,
      ArrivalTime,
      DepartTime,
      flightTime,
      hiddenInputs,
      terminalLocation,
      showTerminalDropdown,
      savedFlight,
      showFlightModal,
      terminal
    } = this.state
    const { agent, typeRID, groupCode } = agentData
    const terminals = this.showTerminals( )
    const arrivalDate = DateHelper.formatDateToDMY( ArrivalDate )
    const departDate = DateHelper.formatDateToDMY( DepartDate )
    const arrivalDateFormatted = DateHelper.formatDateToDddMMyy( ArrivalDate )
    const departDateFormatted = DateHelper.formatDateToDddMMyy( DepartDate )
    const activeClass = classNames({
      'active': selected === 'cp',
      'cp': true,
      'engine': true
    })
    const engineClass = classNames({
      'clearfix': true,
      'hxEmbed': true,
      'terminal': terminals,
      'terminalBelow': terminals && terminalLink,
      'flightDropDown': showFlight && showFlightDropdown,
      'hiddenLocation': hiddenLocation,
      'well': pageName === 'index'
    })
    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'cp',
      selectProduct: 'cp',
      request: '1',
      Referer: 'http://' + domainSettings.domain + '/' + pagesName,
      domain: domainSettings.domain,
      lang: 'en',
      rule_set: formSettings.ruleset
    }

    // flightDate is the date of flight, not shown in the engine but used in the request
    // Also used in TimeSelectFlight component
    const flightDate = this.ensureFlightIsLaterThanArrival()
    const flightInput = {
      inputLabel: 'Enter flight number',
      placeholder: 'Eg. VS27'
    }

    return (
      <div className={ activeClass }>
        <form id="parkingEngine" acceptCharset="UTF-8" action={ formSettings.parkingAction } className={engineClass} method={ formSettings.method }>

          <div className="options">
            <ul className="unstyled">

              { !hiddenLocation ?
                <li className="col-md-2 locationSelect">
                  <div>
                    <label>Flying from?</label>
                    <LocationDropDown activeLocation={ Location || formSettings.defaultParkingLocation } locations={ locations.carParking } onSelect={ this.locationSelected } />
                  </div>
                  { terminals && terminalLink && !showTerminalDropdown && (
                    <a href='#' className='pull-right small' onClick={this.showTerminalField}>Select terminal</a>
                  )}
                  { terminals && terminalLink && showTerminalDropdown && (
                    this.terminalsDropdown()
                  )}
                </li>
              :
                <input name="Location" type="hidden" className="l" value={ hiddenLocation } data-track-name="location" />
              }

              { terminals && !terminalLink && (
                this.terminalsDropdown('col-md-2 terminalContainer')
              )}

              <li className="col-md-3 col-xs-9 calendar">
                <label>Parking from</label>
                <div className="datePicker calendarEmbed">
                  <input className="alternateDA col-xs-12 hxtrack" defaultValue={arrivalDateFormatted} />
                  <input className="dA" name="ArrivalDate" defaultValue={arrivalDate} type="hidden" />
                  <div />
                </div>
              </li>

              <li className="col-md-1 col-xs-3 timeSelect">
                <TimeSelect name="ArrivalTime" onSelect={this.saveTime} activeTime={ ArrivalTime } pagename={ pageName } />
              </li>

              { showFlightDropdown && (
                <li className='col-md-1 col-xs-3 flightTime'>
                  <label htmlFor='FlightTimeCp'>Flight departs</label>
                  <TimeSelectFlight
                    loopOver
                    betweenTimes
                    hourSplit={1}
                    onSelect={this.saveTime}
                    name='flightTime'
                    id='FlightTimeCp'
                    showMidnight
                    startingTime={ArrivalTime}
                    activeTime={flightTime}
                    pagename={pageName}
                  />
                </li>
              )}

              { showFlight && (
                <FlightInput
                  id={'flightInputCP'}
                  name='flight_number'
                  cookieName='FlightNumber'
                  activeFlight={savedFlight}
                  location={terminalLocation}
                  departure={flightDate}
                  departureTime={showFlightDropdown ? flightTime : ArrivalTime}
                  departureTimeMax={showFlightDropdown ? 59 : 400}
                  departureTimeMin={showFlightDropdown ? 0 : 100}
                  terminal={terminal}
                  tip={''}
                  showFlightDropdown={showFlightDropdown}
                  scrollResults
                  placeHolder={showFlightDropdown ? 'Choose flight' : 'Enter Airline'}
                  onChange={this.changedFlight}
                  flightInput={flightInput}
                  arrivalDate={ArrivalDate}
                />
              )}

              <li className="col-md-3 col-xs-9 calendar">
                <label>Returning to collect car</label>
                <div className="datePicker calendarEmbed">
                  <input className="alternateDD col-xs-12 hxtrack" defaultValue={departDateFormatted} />
                  <input className="dD" name="DepartDate" defaultValue={departDate} type="hidden" />
                  <div />
                </div>
              </li>

              <li className="col-md-1 col-xs-3 timeSelect">
                <TimeSelect name="DepartTime" onSelect={this.saveTime} activeTime={ DepartTime } pagename={ pageName } />
              </li>

              <SearchButton column />
            </ul>
          </div>

          <HiddenInputs inputs={ defaultInputs } />
          { engineSearchField && (
            <input name="search" type="hidden" value={ engineSearchField } />
          )}
          <HiddenInputs inputs={ hiddenInputs } />
        </form>
      </div>
    )
  }
})

module.exports = ParkingEngine






// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/parking-engine-horizontal.jsx